import { Component, Inject, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import flow from './flow.json';

export interface ExecutionStep {
  id?:string;
  guid?: string;
  name: string;
  type: string;
  dhStart: string;
  dhEnd: string;
  result: any[];
  parentId?: string;
  outputParameter?: Record<string, any>;
  children?: ExecutionStep[][]; // filhos recursivos
  expanded?:boolean;
  index?:number;
  executionId: number;
  parentExecutionId?: number | null;
  executionPath: string;

}




@Component({
    selector: 'webhook-log-detail',
    templateUrl: './webhook-log.component.html',
    styleUrl: './webhook-log.component.scss',
    standalone: false
})
export class WebhookLogComponent {
  activeItems: any[];

  
  constructor( 
      //@Inject(NZ_MODAL_DATA) private nzdata, 
      private fb: FormBuilder){
      //this.json = JSON.stringify(JSON.parse(this.nzdata), null, 4);
  }

  @Input() data:string | object;
  @Input() children: ExecutionStep[];
  steps: ExecutionStep[] = [];
  selectedStep: ExecutionStep | null = null;
  detailsVisible = false;
  checkedFilterResult:string | null = 'all';



  changeTagChecked(evento, type){
      this.checkedFilterResult = type;
      this.activeItems = this.selectedStep?.result.filter(d=>{
        if (type == 'all'){
            return true;
        }
        if ( type == 'fail' && !d.success){
          return true;
        }

        if ( type == 'success' && d.success){
          return true;
        }
        
        return false;
    })
  }


  ngOnInit() {
    
    if ( this.children != null ){
      this.steps = this.children;
    }else{
      
      //this.data = flow; // temp homolog
      if ( this.data !=null ){
        this.steps = this.normalizeStep(JSON.parse(this.data.toString()) as Record<string, any[]>);
        
        this.steps.sort((A,B)=>{
            let dataA = new Date(A.dhStart);
            let dataB = new Date(B.dhStart);
            return dataA.getTime() - dataB.getTime();

        });  
      }
    }
    console.log(this.steps)
  } 

  

  private parseTimeSafe(v: unknown): number {
  if (typeof v !== 'string') return Number.MAX_SAFE_INTEGER;
  const t = Date.parse(v);
  return isNaN(t) ? Number.MAX_SAFE_INTEGER : t;
}

private sortTreeByStart(steps: ExecutionStep[]): ExecutionStep[] {
  // Ordena o nível atual
  steps.sort((a, b) => this.parseTimeSafe(a.dhStart) - this.parseTimeSafe(b.dhStart));

  for (const s of steps) {
    if (s.children?.length) {
      for (const group of s.children) {
        // ordena cada grupo
        group.sort((a, b) => this.parseTimeSafe(a.dhStart) - this.parseTimeSafe(b.dhStart));

        // percorre cada filho dentro do grupo
        for (const child of group) {
          if (child.children?.length) {
            // flatten manual
            const flattened: ExecutionStep[] = [];
            for (const g of child.children) {
              for (const c of g) {
                flattened.push(c);
              }
            }
            this.sortTreeByStart(flattened);
          }
        }
      }
    }
  }

  return steps;
}


normalizeStep(raw: Record<string, any[]>): ExecutionStep[] {
  const arraySteps: ExecutionStep[] = [];

  // 1. Flatten: agora cada item tem executionId, parentExecutionId, guid e executionPath
  for (const [_, stepsArr] of Object.entries(raw)) {
    if (!Array.isArray(stepsArr)) continue;

    for (const step of stepsArr) {
      const node: ExecutionStep = {
        guid: step.guid,
        executionId: step.executionId,
        parentExecutionId: step.parentExecutionId ?? null,
        name: step?.name,
        type: step?.type,
        dhStart: step?.dhStart,
        dhEnd: step?.dhEnd,
        result: step?.result,
        outputParameter: step?.outputParameter,
        executionPath: step.executionPath,
        children: [] // sempre ExecutionStep[][]
      };

      // INNERFLOW recursivo
      let inner: Record<string, any[]> | null = null;
      if (step?.type === 'INNERFLOW' && Array.isArray(step?.result) && step?.result[0]) {
        inner = step?.result[0]?.innerFlowExecutionList ?? null;
      }
      if (inner && typeof inner === 'object') {
        const innerNormalized = this.normalizeStep(inner);
        if (innerNormalized.length) {
          node.children.push(innerNormalized); // adiciona grupo inteiro
        }
      }

      arraySteps.push(node);
    }
  }

  // 2. Index por executionId
  const byId = new Map<number, ExecutionStep>();
  for (const s of arraySteps) {
    byId.set(s.executionId, s);
  }

  // helper: dado o path do pai e do filho, extrai o índice da iteração
  const getGroupIndexFromPaths = (parentPath: string, childPath: string): number => {
    const p = parentPath.split('/').filter(Boolean);
    const c = childPath.split('/').filter(Boolean);

    // tudo que vem depois do path do pai
    const tail = c.slice(p.length);

    // padrão do teu JSON: [GUID, ITER]
    const iterSegment = tail[1]; // ex: "0" em .../LISTA/0 ou .../PROCEDURE_EXECUTION/0
    const n = Number(iterSegment);
    return Number.isFinite(n) ? n : 0;
  };

  // 3. Linkar pai → filhos via parentExecutionId, agrupando por iteração correta
  for (const node of arraySteps) {
    if (node.parentExecutionId == null) continue;

    const parent = byId.get(node.parentExecutionId);
    if (!parent) continue;

    const groupIndex = getGroupIndexFromPaths(parent.executionPath, node.executionPath);

    if (!parent.children[groupIndex]) {
      parent.children[groupIndex] = [];
    }
    parent.children[groupIndex].push(node);
  }

  // 4. Raízes = sem parentExecutionId
  const roots = arraySteps.filter(s => s.parentExecutionId == null);

  // 5. Ordenação profunda
  return this.sortTreeByStart(roots);
}






 
  getColor(success: boolean): string {
    return success ? 'green' : 'red';
  }

  openDetails(step: ExecutionStep) {
    this.selectedStep = step;
    this.detailsVisible = true;
    this.activeItems = this.selectedStep?.result;
  }

  formatJSON(json):object{
        if( json == null ) return;

        try{
            let ob = JSON.parse(JSON.stringify(json));
            return JSON.parse(JSON.stringify(json));
            
        }catch(erro){
            return null;
        }
  }

  formatJSONViewer(json):string{
        try{
            if ( json instanceof String){
                return JSON.stringify(JSON.parse(json.toString()),null,2);
            }else{
                return JSON.stringify(json,null,2);
            }
            
        }catch(erro){
            return erro;
        }
  }
}
